import { Redirect, Route, RouteProps } from 'react-router-dom'

import { useAppSelector } from 'app/hooks'
import { hasSubscriptionPermissionSelector } from 'features/auth/permissions/selectors'

const SubscriptionRoute = ({ path, children }: RouteProps) => {
  const hasSubscriptionPermission = useAppSelector(
    hasSubscriptionPermissionSelector
  )
  return (
    <Route path={path}>
      {hasSubscriptionPermission ? children : <Redirect to="/" />}
    </Route>
  )
}

export default SubscriptionRoute
